import ContentLoader from 'react-content-loader'

export const ProductsSkeleton = () => (
    <ContentLoader speed={2} width={600} height={350} viewBox="0 0 900 330" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="0" y="0" rx="3" ry="3" width="300" height="330" />
        <rect x="200" y="0" rx="3" ry="3" width="300" height="330" />
        <rect x="400" y="0" rx="3" ry="3" width="300" height="330" />
    </ContentLoader>
)
